export default __webpack_public_path__ + "assets/front/scss/affichage-timeline.458cb2f7075f219bb25739b2a884a16b.css";